const defaultConfig = {
  layer: 'view',
  section: 'lookiero-app',
  environment: undefined,
  ignoredErrors: [],
  beforeSend: <T>(event: T): T => event,
};

export {defaultConfig};
